import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.225 11.784a.715.715 0 010-1.04l8.215-7.528A.782.782 0 0112 3a.782.782 0 01.56.216l8.215 7.527c.3.288.3.754 0 1.041a.79.79 0 01-1.085 0l-.19-.174v8.64a.75.75 0 01-.745.75H14.25a.75.75 0 01-.75-.75V16.5h-3v3.75a.75.75 0 01-.75.75h-4.5a.75.75 0 01-.75-.75v-8.64l-.19.174a.79.79 0 01-1.085 0zM6 10.236V19.5h3v-3.75a.75.75 0 01.75-.75h4.5a.75.75 0 01.75.75v3.75h3v-9.264l-6-5.498-6 5.498z",
  clipRule: "evenodd"
})), "IconHome");